function handleFilters() {
  const $filterOptions = document.querySelectorAll('.filter-button');

  if ($filterOptions && $filterOptions.length > 4) {
    const $moreFiltersBtn = document.querySelector('.more-filters-button');
    const $extraOptions = Array.from($filterOptions).slice(4);

    $moreFiltersBtn.innerText = "More filters";
    $moreFiltersBtn.classList.remove('hide');

    $extraOptions.forEach(($option) => {
      $option.classList.add('hide');
    });

    $moreFiltersBtn.addEventListener('click', function() {
      if (this.getAttribute('open')) {
        this.removeAttribute('open');
        this.innerText = "More filters";

        $extraOptions.forEach(($option) => {
          $option.classList.add('hide');
        });
      } else {
        this.setAttribute('open', 'true');
        this.innerText = "Hide filters";

        $extraOptions.forEach(($option) => {
          $option.classList.remove('hide');
        });
      }
    });
  }
}

function onlyUnique(value, index, array) {
  return array.indexOf(value) === index;
}

document.addEventListener("DOMContentLoaded", handleFilters);

class SearchField extends HTMLElement {
  constructor() {
    super();
    this.listen();
  }

  listen() {
    const input = this.querySelector("input");
    const mobileButton = this.querySelector(".icon");
    input.addEventListener('keyup', (e) => this.search(e.target.value));
    mobileButton.addEventListener('click', (e) => {
      document.querySelector('filter-buttons')?.removeAttribute('open');
    });
    mobileButton.addEventListener('click', () => this.toggleActive());
    document.addEventListener('click', (e) => {
      if (!this.contains(e.target) && !input.value) this.removeAttribute('open');
    });
  }

  toggleActive() {
    this.getAttribute('open') ? this.removeAttribute('open') : this.setAttribute('open', true);
  }

  search(value) {
    value = value.toLowerCase();
    const sections = document.querySelectorAll(".filterable");
    if (!sections) return;
    sections.forEach((section) => {
      const text = this.normalizeText(this.getTextContent(section));
      if (text.includes(value)) {
        section.classList.remove("hide");
      } else {
        section.classList.add("hide");
      }
    });
  }
  
  normalizeText(text) {
    return text.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();
  }

  getTextContent(element) {
    let text = element.textContent;
    if (element.children.length > 0) {
      for (let child of element.children) {
        text += this.getTextContent(child);
      }
    }
    return text;
  }
}

customElements.define("search-field", SearchField);

class FilterButtons extends HTMLElement {
  constructor() {
    super();
    this.sections = document.querySelectorAll(".filterable");
    this.template = document.querySelector("#FilterButtons");
    const clone = this.template.content.cloneNode(true);
    const button = clone.querySelector(".filter-button");
    const allTranslation = window.translations;

    button.classList.add("active");
    button.innerHTML = `<span>${allTranslation}</span>`;
    button.addEventListener("click", (e) => this.listen(e));
    this.appendChild(button);

    const mobileButton = document.querySelector('.filter__heading-mobile');
    mobileButton.addEventListener('click', (e) => {
      this.getAttribute('open') ? this.removeAttribute('open') : this.setAttribute('open', true);
    })
    this.renderButtons(this.sections);
  }

  clearActive() {
    const buttons = document.querySelectorAll(".filter-button");
    buttons.forEach((button) => button.classList.remove("active"));
  }

  clearFilters() {
    this.sections.forEach((section) => section.classList.remove("hide"));
  }

  listen(e) {
    e.preventDefault();
    this.clearActive();
    const button = e.target.closest(".filter-button");
    button.classList.add("active");
    
    if (!button.getAttribute("section-id")) {
      this.clearFilters();
      return;
    }
    
    this.sections.forEach((section) => {
      if (section.id == button.getAttribute("section-id")) {
        section.classList.remove("hide");
      } else {
        section.classList.add("hide");
      }
    });
  }

  listenTags(e) {
    e.preventDefault();
    this.clearActive();
    const button = e.target.closest(".filter-button");
    button.classList.add("active");
    
    if (!button.getAttribute("tag-value")) {
      this.clearFilters();
      return;
    }

    const tagValue = button.getAttribute("tag-value");
    
    this.sections.forEach((section) => {
      if (!section.dataset.tags) {
        section.classList.add('hide');
        return;
      }

      const splitTags = section.dataset.tags.split(',');
      const cleanTags = splitTags.map(tag => tag.trim().toLowerCase());
      
      if (cleanTags.includes(tagValue)) {
        section.classList.remove('hide');
      } else {
        section.classList.add('hide');
      }
    });
  }

  renderButtons(sections) {
    if (!sections) return;

    const sectionsArray = Array.from(sections);
    const isTagsFilter = sectionsArray.some(section => section.dataset.tags !== null);

    if (isTagsFilter) {
      const tags = [];
      
      sections.forEach((section) => {
        if (!section.dataset.tags) return;
        const sectionTags = section.dataset.tags.split(',');
        tags.push(sectionTags);
      });

      const cleanTags = tags.flat().map(tag => tag.toLowerCase().trim());
      const uniqueTags = cleanTags.filter(onlyUnique);

      if (!uniqueTags) return;

      uniqueTags.forEach((tag) => {
        const clone = this.template.content.cloneNode(true);
        const button = clone.querySelector(".filter-button");
        
        button.setAttribute("tag-value", tag);
        button.innerHTML = `<span>${tag}</span>`;
        button.addEventListener("click", (e) => this.listenTags(e));
        this.appendChild(button);
      });
    } else {
      sections.forEach((section) => {
        const clone = this.template.content.cloneNode(true);
        const button = clone.querySelector(".filter-button");
        
        const sectionTitle = section.querySelector("h2")?.innerText;
        if (!sectionTitle) return;
        button.setAttribute("section-id", section.id);
        button.innerHTML = `<span>${sectionTitle}</span>`;
        button.addEventListener("click", (e) => this.listen(e));
        this.appendChild(button);
      });
    }

    const clone = this.template.content.cloneNode(true);
    const moreFiltersBtn = clone.querySelector('.more-filters-button');
    this.appendChild(moreFiltersBtn);
  }
}

customElements.define("filter-buttons", FilterButtons);
